export enum FeedbackType {
    BUG = 1,
    FEEDBACK = 2
}
